import React from 'react'
import {graphql} from 'gatsby'

import Layout from '../components/layout/layout'
import {createLinkDocs} from "../utils/createLink";
import {findSectionForPath} from "../utils/findSectionForPath"
import Sidebar from '../components/sidebar/sidebar'
import Page from '../components/page/page'
import {locales, getCurrentLocale} from "../utils/getCurrentLocale";


export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
      }
      html
    }
  }
`;

// TODO: next and prev button
const DocTemplate = (props) => {

    let locale = getCurrentLocale(props.location.pathname);

    return (
        <Layout location={props.location}>
            <Sidebar activeSection={findSectionForPath(props.location.pathname, locales[locale])}
                     sectionList={locales[locale]} createLink={createLinkDocs} location={props.location}/>
            <Page markdownRemark={props.data.markdownRemark}/>
        </Layout>
    )
};

export default DocTemplate